module.exports = __webpack_public_path__ + "img/profile.f2aba9c1.svg";